import { downloadReport as downloadReportApi } from "../api";


export const downloadReport = async (report) => {
  try {
    const { data } = await downloadReportApi(report.id);

    const url = window.URL.createObjectURL(data);

    const link = document.createElement("a");
    link.href = url;
    link.download = report.fileName;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Failed to download report:", err);
  }
};


export const downloadAllReports = async (reports) => {
  for (const report of reports) {
    await downloadReport(report);

    await new Promise((resolve) => setTimeout(resolve, 300));
  }
};
